<template>
  <div class="final">
    <el-card class="final__card" v-if="selectedOffer">
      <el-row :gutter="20">
        <el-col :xs="24" :sm="8">
          <el-card>
            <div class="card">
              <font-awesome-icon
                :icon="['fal', 'home-lg-alt']"
                size="lg"
                class="card__icon"
              />
              <h3 class="card__title center-v-h">
                {{ $t('home.final.moving.title') }}
              </h3>
              <h4 class="card__subtitle center-v-h">
                {{ moving }}
              </h4>
              <p class="card__text">
                {{ $t('home.final.moving.loadingDate') }}
                {{ dateFrom }}
              </p>
              <p class="card__text">
                {{ $t('home.final.moving.deliveryDate') }}
                {{ dateTo }}
              </p>
              <p class="card__text card__text--formule">
                {{ selectedOffer.formule
                    && $t(`home.final.moving.formule.${selectedOffer.formule.toLowerCase()}`)
                }}
              </p>
            </div>
          </el-card>
        </el-col>
        <el-col :xs="24" :sm="8">
          <el-card>
            <div class="card">
              <font-awesome-icon
                :icon="['fal', 'truck-moving']"
                size="lg"
                class="card__icon"
              />
              <h3 class="card__title center-v-h">
                {{ $t('home.final.mover.mover') }}
              </h3>
              <h4 class="card__subtitle center-v-h">
                {{ selectedOffer.mover.name }}
              </h4>
              <p class="card__text">
                {{ $t('home.final.mover.contact') }} :
              </p>
              <p class="card__text">
                <span class="bold break-word">{{ selectedOffer.contact.email }}</span>
              </p>
              <p class="card__text">
                <span class="bold">{{ selectedOffer.contact.phone_office }}</span>
              </p>
            </div>
          </el-card>
        </el-col>
        <el-col :xs="24" :sm="8">
          <el-card>
            <div class="card">
              <font-awesome-icon
                :icon="['fal', 'info-circle']"
                size="lg"
                class="card__icon"
              />
              <h3 class="card__title center-v-h">
                {{ $t('home.final.assurance.title') }}
              </h3>
              <h4 class="card__subtitle center-v-h">
                {{ selectedOffer.assurance_type }}
              </h4>
              <p class="card__text">
                <span>{{ selectedOffer.assurance.description }}</span>
              </p>
              <p class="card__text">
                <span>{{ selectedOffer.franchise.description }}</span>
              </p>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <div class="final__card__actions">
        <router-link :to="{ name: 'details' }">
          <el-button type="success">
            {{ $t('home.final.btn') }}
          </el-button>
        </router-link>
      </div>
    </el-card>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import demandHelper from '@/utils/helpers/demand';

export default {
  name: 'final',
  computed: {
    ...mapGetters({
      selectedOffer: 'offerStore/selectedOffer',
      demand: 'demandStore/demand',
    }),
    moving() {
      return `${this.demand.from_address.city} - ${this.demand.to_address.city}`;
    },
    dateFrom() {
      return demandHelper.formatFinalLoadingDates(
        this.demand,
        this.selectedOffer,
        'short',
      );
    },
    dateTo() {
      return demandHelper.formatFinalDeliveryDates(
        this.demand,
        this.selectedOffer,
        'short',
      );
    },
  },
};
</script>

<style scoped lang="scss">
.final {
  margin: 20px 0;
  @include breakpoint(tablet) {
    margin: 20px;
  }
  @include breakpoint(wide) {
    margin: 20px $--wide-margin;
  }
  @include breakpoint(wide-xl) {
    margin: 20px $--wide-xl-margin;
  }
  &__card {
    border-radius: 0;
    @include breakpoint(tablet) {
      border-radius: 4px;
    }
    .el-row {
      @include breakpoint(tablet) {
        display: flex;
      }
    }
    .el-card {
      margin-bottom: 20px;
      @include breakpoint(tablet) {
        height: 100%;
        margin-bottom: 0;
      }
    }
    .card {
      display: flex;
      flex-direction: column;
      align-items: center;
      @include breakpoint(tablet) {
        //height: 280px;
      }
      &__icon {
        text-align: center;
        margin-bottom: 10px;
      }
      &__title {
        margin-top: 0;
        text-align: center;
        margin-bottom: 10px;
        @include breakpoint(tablet) {
          min-height: 55px;
        }
      }
      &__subtitle {
        text-align: center;
        border-radius: 3px;
        min-height: 40px;
        background: $--color-lightest-blue;
        width: 100%;
        margin-top: 0;
        margin-bottom: 10px;
        @include breakpoint(tablet) {
          min-height: 70px;
        }
      }
      &__text {
        margin-top: 0;
        font-size: 16px;
        margin-bottom: 5px;
        text-align: center;
        &--formule {
          margin-top: 10px;
        }
      }
    }
    &__actions {
      margin-top: 20px;
      text-align: center;
    }
  }
}
.bold {
  font-weight: 600;
}
.break-word {
  word-wrap: break-word;
}
</style>
